// The Rails environment: development, test, staging, production.
export const environment = import.meta.env.MODE!

export const isTest = environment === 'test'
export const isDevelopment = environment === 'development'
export const isStaging = environment === 'staging'
export const isProduction = environment === 'production'

const userAgent = String((typeof navigator !== 'undefined') && navigator.userAgent)
export const isSafari = userAgent.includes('Safari') && !userAgent.includes('Chrome')
export const isMac = /Mac|iP(hone|ad|od)/.test(userAgent)
